const openHouseModal = (state = false, action) =>
  action.type === 'OPEN_HOUSE_MODAL' ? !state : state
export default openHouseModal
